import React, { Component } from 'react'
import { Container, Row, Col } from 'reactstrap'
import {Image} from 'react-bootstrap'

import logo from '../images/brand.png'

export default class Home extends Component {
  render () {
    return (
      <Container className={'vCenter h80vh'}>
        <div className={'w100p'}>
          <div className={'txtcenter'}>
            <Image src={logo} responsive className={'w30p'} />
          </div>
          <Row className={'mT-7'}>
            <Col md={{size: 4, offset: 4}} className={''}>
              <h1 className={'oswald txtcenter yellow-ititoca'}>BACK-OFFICE</h1>
            </Col>
          </Row>
          <hr />
          <h1 className="txtcenter">Gérez vos utilisateurs ainsi que votre contenu.</h1>
        </div>
      </Container>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/Home.js